import { Routes, Route, Navigate } from 'react-router-dom'
import Login from './routes/Login'
import Dashboard from './routes/Dashboard'
import Plan from './routes/Plan'
import Positions from './routes/Positions'
import CryptoJournal from './routes/CryptoJournal'
import News from './routes/News'
import Clusters from './routes/Clusters'
import USEquity from './routes/USEquity'
import Backtest from './routes/Backtest'
import Calendar from './routes/Calendar'
import Guardrail from './routes/Guardrail'
import Jobs from './routes/Jobs'
import Settings from './routes/Settings'
import Layout from './components/Layout'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/plan" element={<Plan />} />
        <Route path="/positions" element={<Positions />} />
        <Route path="/crypto-journal" element={<CryptoJournal />} />
        <Route path="/news" element={<News />} />
        <Route path="/clusters" element={<Clusters />} />
        <Route path="/us-equity" element={<USEquity />} />
        <Route path="/backtest" element={<Backtest />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/guardrail" element={<Guardrail />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
